import type { ContextProps } from './Context'
import { Provider } from './Context'
import { Layout } from './Layout'

export type { ContextProps as AssetContainerProps }

export const AssetContainer = (props: ContextProps) => {
  return (
    <Provider {...props}>
      <Layout />
    </Provider>
  )
}
